// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".JobList-module__jobResultsContainer___\\+gaHl{\n    width: 100%;\n    padding: 5px 7px;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    grid-gap: 12px;\n    grid-gap: 12px;\n    gap: 12px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"jobResultsContainer": "JobList-module__jobResultsContainer___+gaHl"
};
export default ___CSS_LOADER_EXPORT___;
